<template>
  <div>
    <BreadCrumb class="bread" :breads="['设备管理', '货柜管理']"></BreadCrumb>
    <div class="wrap">
      <div class="header">
        <span class="nameFt">货柜管理</span>
      </div>
      <div class="submit-form">
        <el-form :model="search" :inline="true" size="small" label-width="80px">
          <div class="submit-form__search">
            <el-form-item label="机器编号">
              <el-input size="small" v-model="search.hard_number"></el-input>
            </el-form-item>
            <el-form-item label="机器名称">
              <el-input
                size="small"
                v-model="search.terminal_number"
              ></el-input>
            </el-form-item>
            <el-form-item label="产品型号">
              <el-input
                size="small"
                v-model="terminal_type.name"
                suffix-icon="el-icon-search"
                readonly
                @focus="setDialogSearchItem('terminal_types')"
              ></el-input>
            </el-form-item>
            <el-form-item label="管理状态">
              <el-select
                class="selectWin"
                v-model="search.status"
                size="small"
                placeholder="管理状态"
              >
                <el-option
                  v-for="(item, key) in typeOptions"
                  :key="key"
                  :label="item"
                  :value="key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="线路">
              <el-input
                size="small"
                v-model="line.name"
                suffix-icon="el-icon-search"
                readonly
                @focus="setDialogSearchItem('line')"
              ></el-input>
            </el-form-item>
            <el-form-item label="点位">
              <el-input
                size="small"
                v-model="point.name"
                suffix-icon="el-icon-search"
                readonly
                @focus="setDialogSearchItem('point')"
                :disabled="!search.line_id"
              ></el-input>
            </el-form-item>
            <el-form-item label="点位类型">
              <el-input
                size="small"
                v-model="point_type.name"
                suffix-icon="el-icon-search"
                readonly
                @focus="setDialogSearchItem('pointType')"
              ></el-input>
            </el-form-item>
            <el-form-item label="网络状态">
              <el-select
                placeholder="网络状态"
                class="selectWin"
                v-model="search.network_status"
                size="small"
              >
                <el-option
                  v-for="(item, key) in network"
                  :key="key"
                  :label="item"
                  :value="key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-checkbox size="small" v-model="search.is_join">联合查询</el-checkbox>
            </el-form-item>
          </div>
          <div class="submit-form__operate">
            <el-form-item>
              <el-button
                class="queryBtn"
                size="small"
                type="primary"
                @click="searchBtn('cl')"
                >查询</el-button
              >
              <el-button
                class="queryBtn"
                size="small"
                type="primary"
                @click="resetBtn"
                >重置</el-button
              >
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="operate-con">
        <el-button
          class="queryBtn"
          size="small"
          type="primary"
          @click="addBtn"
          v-show="
            $store.getters.authority({ name: 'cabinetManage', type: 'add' })
          "
          >新增</el-button
        >
        <el-button
          class="queryBtn"
          size="small"
          type="primary"
          @click="outDown"
          v-show="
            $store.getters.authority({ name: 'cabinetManage', type: 'view' })
          "
          >导出</el-button
        >
        <!-- <el-button
          class="queryBtn"
          size="small"
          type="primary"
          @click="printBtn"
          v-show="
            $store.getters.authority({ name: 'cabinetManage', type: 'view' })
          "
          >打印</el-button
        > -->
        <el-button
          class="queryBtn"
          size="small"
          type="primary"
          @click="openStockHistory"
          >历史库存</el-button
        >
        <!-- <el-button
          style="width:150px"
          class="queryBtn"
          size="small"
          type="primary"
          @click="printBtn"
          v-show="
            $store.getters.authority({ name: 'cabinetManage', type: 'view' })
          "
          >打印</el-button
        > -->
        <el-button
          style="width: 150px"
          class="queryBtn"
          size="small"
          type="primary"
          @click="printBtn"
          >导出机器明细库存</el-button
        >
        <el-button size="small" type="primary" @click="controlVolume()"
          >音量批量控制</el-button
        >
        <el-button size="small" type="primary" @click="controlTemperature()"
          >温度批量控制</el-button
        >
        <el-button size="small" type="primary" @click="controlHardNumber()"
          >待运营机器</el-button
        >
        <!-- <div class="operate-flex">
          <div >
            在线机器：{{ this.lineCount.online_count }}台
          </div>
          <div>离线机器：{{ this.lineCount.offline_count }}台</div>
        </div> -->
      </div>
      <div class="table-con">
        <el-table
          ref="sortTable"
          :data="tableList"
          stripe
          id="table"
          :row-class-name="tableRowClassName"
          :default-sort="{ prop: 'network_status', order: 'ascending' }"
          @sort-change="changeTableSort"
        >
          <el-table-column
            label="序号"
            type="index"
            align="center"
            :index="indexMethod"
          ></el-table-column>
          <el-table-column
            prop="hard_number"
            label="机器编号"
            align="center"
            key="hard_number"
          ></el-table-column>
          <!-- <el-table-column
            prop=""
            width="100px"
            label="门锁状态"
            align="center"
          >
            <template slot-scope="scope">
              <div
                v-if="
                  scope.row.door_status == '门关' &&
                  scope.row.lock_status == '锁开'
                "
                :class="
                  scope.row.door_status == '门关' ||
                  scope.row.lock_status == '锁开'
                    ? 'text-warning'
                    : ''
                "
              >
                {{ scope.row.door_status }} {{ scope.row.lock_status }}
              </div>
              <div
                v-if="
                  scope.row.door_status == '门开' &&
                  scope.row.lock_status == '锁开'
                "
                :class="
                  scope.row.door_status == '门开' ||
                  scope.row.lock_status == '锁开'
                    ? 'text-success'
                    : ''
                "
              >
                {{ scope.row.door_status }} {{ scope.row.lock_status }}
              </div>
              <div
                v-if="
                  scope.row.door_status == '门开' &&
                  scope.row.lock_status == '锁关'
                "
                :class="
                  scope.row.door_status == '门开' ||
                  scope.row.lock_status == '锁关'
                    ? 'text-error'
                    : ''
                "
              >
                {{ scope.row.door_status }} {{ scope.row.lock_status }}
              </div>
              <div
                v-if="
                  scope.row.door_status == '门关' &&
                  scope.row.lock_status == '锁关'
                "
                :class="
                  scope.row.door_status == '门关' ||
                  scope.row.lock_status == '锁关'
                    ? 'text-grey'
                    : ''
                "
              >
                {{ scope.row.door_status }} {{ scope.row.lock_status }}
              </div>
            </template></el-table-column
          > -->
          <el-table-column
            prop="terminal_number"
            label="机器名称"
            width="250px"
          >
            <template slot-scope="scope">
              <el-input
                v-if="
                  scopeObj.id === scope.row.id &&
                  scopeObj.lable === scope.column.lable
                "
                v-model="scope.row.terminal_number"
                ref="iptRef"
                @blur="inputBlur(scope.row)"
              >
              </el-input>
              <span v-else>
                <span>{{ scope.row.terminal_number }}</span>
                <i class="el-icon-edit" @click="edit(scope)"></i>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="terminal_type_name"
            label="产品型号"
            align="center"
            key="terminal_type_name"
          ></el-table-column>
          <el-table-column label="温湿度" width="142px" align="center">
            <template slot-scope="scope">
              <div class="temper">
                <div @click="openTemperature(scope.row)">
                  {{ scope.row.temperature }}°C
                </div>
                <div>{{ scope.row.humidity }}%</div>
              </div>
              <div class="temper" @click="drawLine(scope.row)">
                <img
                  class="icon-iconCodes"
                  src="@/assets/images/common/humidity.png"
                  alt="温湿度"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="sound" label="音量" align="center">
            <div slot-scope="scope">
              <el-button
                type="text"
                size="small"
                class="unset"
                @click="openSound(scope.row)"
                >{{ scope.row.volume }}</el-button
              >
            </div>
          </el-table-column>
          <el-table-column
            label="摄像头状态(主/副)"
            width="110px"
            align="center"
            prop="aa"
            key="aa"
          >
            <template slot-scope="scope">
              <span
                :class="
                  scope.row.main_camera_status !== '正常'
                    ? 'text-error'
                    : 'text-success'
                "
              >
                {{ scope.row.main_camera_status }}
              </span>
              <span>/</span>
              <span
                :class="
                  scope.row.sub_camera_status !== '正常'
                    ? 'text-error'
                    : 'text-success'
                "
              >
                {{ scope.row.sub_camera_status }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="货柜状态"
            width="142px"
            align="center"
            key="status"
            :sort-orders="['ascending', 'descending']"
            sortable="custom"
            prop="network_status"
          >
            <template slot-scope="scope">
              <div
                :class="
                  scope.row.hard_status !== '正常' ||
                  scope.row.network_status !== '在线'
                    ? 'text-warning'
                    : 'text-success'
                "
              >
                {{ scope.row.hard_status }} {{ scope.row.network_status }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="网络强度" align="center" key="1">
            <template slot-scope="scope">
              <el-button
                @click="getNetworkStrength(scope.row.hard_number)"
                size="small"
                type="text"
              >
                {{
                  { LOW: "低", MID: "中", HIGH: "高" }[
                    scope.row.network_strength
                  ]
                }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="管理状态" prop="status" align="center">
            <template slot-scope="scope">
              <div :class="scope.row.status == '下线' ? 'text-warning' : ''">
                {{ scope.row.status }}
              </div>
              <span v-if="scope.row.status == '下线'"
                >原因：{{ scope.row.offline_cause }}</span
              >
            </template>
          </el-table-column>
          <!-- <el-table-column prop="num" label="今日销售" align="center">
            <template slot-scope="scope">
              <div>
                {{ scope.row.real_amount }}元/共{{
                  scope.row.total_order_count
                }}单
              </div>
            </template>
          </el-table-column> -->
     
          <el-table-column
            prop="line_name"
            label="线路"
            align="center"
          ></el-table-column>
          <el-table-column prop="point_name" label="点位" align="center">
            <div slot-scope="scope">
              <div>{{ scope.row.point_name }}</div>
              <div>
                <el-button
                  type="primary"
                  size="small"
                  @click="Relocation(scope.row)"
                  >移机</el-button
                >
              </div>
            </div>
          </el-table-column>
          <el-table-column
            prop="point_type"
            label="点位类型"
            align="center"
          ></el-table-column>
        
          <el-table-column
            prop="updated_at"
            label="更新时间"
            align="center"
          ></el-table-column>
          <el-table-column prop="auto_clean" label="是否自动清理空单">
            <div slot-scope="scope">
              <el-switch
                v-model="scope.row.auto_clean"
                @change="changeEmptyOrder(scope.row)"
              ></el-switch>
            </div>
          </el-table-column>
          <el-table-column label="二维码" width="60px" align="center">
            <div slot-scope="scope">
              <i
                class="el-icon-menu"
                @click="openQrcode(scope.row.hard_number)"
              ></i>
            </div>
          </el-table-column>
          <!-- <el-table-column
            prop="updated_at"
            label="柜贴二维码"
            align="center"
            v-if="!printVisible"
            v-show="
              $store.getters.authority({ name: 'cabinetManage', type: 'view' })
            "
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="goDown(scope.row, 'GW')"
                >下载</el-button
              >
            </template>
          </el-table-column> -->
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="250px"
            v-if="!printVisible"
          >
            <template slot-scope="scope">
              <!-- <el-button
                size="small"
                type="text"
                @click="openVideoView(scope.row.hard_number)"
                v-show="
                  $store.getters.authority({
                    name: 'cabinetManage',
                    type: 'view',
                  })
                "
                >视频下载</el-button
              > -->

              <el-button
                style="margin-right: 10px"
                size="small"
                type="text"
                @click="stockView(scope.row.hard_number)"
                >明细库存</el-button
              >

              <!-- <el-dropdown
                size="small"
                class="mr15"
                trigger="click"
                @command="stockView"
              >
                <el-button size="small" type="text">
                  库存
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="1"
                    :hard_number="scope.row.hard_number"
                    >明细库存</el-dropdown-item
                  >
                  <el-dropdown-item
                    command="2"
                    :hard_number="scope.row.hard_number"
                    >实时图片</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown> -->

              <!-- <el-button size="small" type="text" class="mr15" @click="exhibit(scope.row)">库存</el-button> -->

              <el-dropdown
                size="small"
                class="mr15"
                trigger="click"
                @command="stockOperate"
                v-show="
                  $store.getters.authority({
                    name: 'cabinetManage',
                    type: 'update',
                  })
                "
              >
                <!-- 库存操作隐藏 -->
                <!-- <el-button size="small" type="text">
                  库存操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button> -->
                <el-dropdown-menu
                  slot="dropdown"
                  v-if="scope.row.status_name !== 'EXPIRE'"
                >
                  <el-dropdown-item
                    command="online"
                    :hard_number="scope.row.hard_number"
                    >商品上架</el-dropdown-item
                  >
                  <el-dropdown-item
                    command="offline"
                    :hard_number="scope.row.hard_number"
                    >商品下架</el-dropdown-item
                  >
                  <!-- <el-dropdown-item command="changeGoods" :hard_number="scope.row.hard_number">同类商品更换</el-dropdown-item> -->
                  <el-dropdown-item
                    command="changeGoodsWay"
                    :hard_number="scope.row.hard_number"
                    >更换货道商品</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown
                size="small"
                class="mr15"
                @command="btnDetal"
                trigger="click"
                v-show="
                  $store.getters.authority({
                    name: 'cabinetManage',
                    type: 'update',
                  })
                "
              >
                <el-button size="small" type="text">
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in operationList"
                    :key="index"
                    :command="item.value"
                    :hard_number="scope.row.hard_number"
                  >
                    <span
                      v-if="
                        !(
                          scope.row.status_name === 'EXPIRE' &&
                          item.label !== '查看'
                        )
                      "
                      >{{ item.label }}</span
                    >
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown
                size="small"
                trigger="click"
                @command="machineOperate"
                v-show="
                  $store.getters.authority({
                    name: 'cabinetManage',
                    type: 'update',
                  })
                "
              >
                <el-button size="small" type="text">
                  机器操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="online"
                    :itemId="scope.row.id"
                    v-if="scope.row.status_name === 'TAKE_DOWNLINE'"
                    >上线</el-dropdown-item
                  >
                  <el-dropdown-item
                    command="offline"
                    :itemId="scope.row.id"
                    v-if="scope.row.status_name === 'OPERATE'"
                    >下线</el-dropdown-item
                  >
                  <el-dropdown-item
                    command="unlock"
                    :hard_number="scope.row.hard_number"
                    v-if="scope.row.network_status === '在线'"
                    >强制开锁</el-dropdown-item
                  >
                  <el-dropdown-item
                    command="update_lock_status"
                    :hard_number="scope.row.hard_number"
                    v-if="scope.row.network_status === '在线'"
                    >清锁状态</el-dropdown-item
                  >
                  <el-dropdown-item
                    command="restart"
                    :hard_number="scope.row.hard_number"
                    >重启机器</el-dropdown-item
                  >
                  <el-dropdown-item
                    command="logDownload"
                    :hard_number="scope.row.hard_number"
                    >日志下载</el-dropdown-item
                  >
                  <!-- <el-dropdown-item
                    command="operated"
                    :hard_number="scope.row.hard_number"
                    >待运营机器</el-dropdown-item
                  > -->
                  <el-dropdown-item command="volume" :row="scope.row"
                    >音量调整</el-dropdown-item
                  >
                  <el-dropdown-item command="temperature" :row="scope.row"
                    >温度调整</el-dropdown-item
                  >
                  <el-dropdown-item command="detailsInformation" :row="scope.row"
                    >机器详情</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginationWrap">
          <!-- <el-pagination
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="search.page_index"
            :layout="pageLayout"
            :total="total"
          ></el-pagination> -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10,20,30,50,100]"
            :page-size="search.pageSize"
            :current-page="search.page_index"
            layout="total,sizes, prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
      <!-- <cabinetechart ref="cabinetechart"></cabinetechart> -->
      <cabinetNetworkChart ref="cabinetNetworkChart"></cabinetNetworkChart>
    </div>

    <!--经纬度-->
    <el-dialog
      class="reload_dialog"
      title="请选择位置"
      :visible.sync="Lat_dialog"
      @close="Lat_Close"
      width="450px"
    >
      <el-form
        :model="latModel"
        :inline="true"
        status-icon
        :rules="latRules"
        ref="latForm"
      >
        <el-form-item prop="province">
          <el-select
            v-model="latModel.province"
            @change="provinceChange"
            class="lineItem"
            size="small"
            placeholder="请选择"
          >
            <el-option
              v-for="item in province_options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <span class="leftMrgin">省</span>
        </el-form-item>
        <el-form-item prop="city">
          <el-select
            v-model="latModel.city"
            @change="cityChange"
            class="lineItem"
            size="small"
            placeholder="请选择"
          >
            <el-option
              v-for="item in city_options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <span class="leftMrgin">市</span>
        </el-form-item>
        <el-form-item prop="area">
          <el-select
            v-model="latModel.area"
            class="lineItem"
            size="small"
            placeholder="请选择"
          >
            <el-option
              v-for="item in area_options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <span class="leftMrgin">区</span>
        </el-form-item>
        <el-form-item prop="address" class="blockAddarea" label="详细地址:">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入详细地址"
            v-model="latModel.address"
          ></el-input>
        </el-form-item>
        <el-form-item class="btngroupCenter">
          <el-button type="success" @click="LatHand" :loading="loading"
            >确 认</el-button
          >

          <el-button :disabled="loading" @click="Lat_dialog = false"
            >取 消</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--下线 + 上线-->
    <el-dialog class="XX_dialog" :visible.sync="XX_dialog" width="30%" center>
      <div slot="title">
        <i class="el-icon-warning"></i>
      </div>
      <div class="Main">
        <div class="infoOne">
          确定要{{
            downData.status_name !== "OPERATE" ? "上线" : "下线"
          }}该机器吗？
        </div>
        <div class="infoTwo" v-if="downData.status_name === 'OPERATE'">
          下线后用户无法开门购买，请谨慎操作！
        </div>
      </div>
      <div style="margin-top: 30px; margin-left: 110px">
        <el-form size="small" label-width="80px">
          <el-form-item label="下线原因">
            <el-input
              style="width: 200px"
              size="small"
              v-model="downData.offline_cause"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="loading" @click="XX_dialog = false"
          >取 消</el-button
        >
        <el-button
          type="danger"
          @click="
            downData.status_name === 'TAKE_DOWNLINE'
              ? downHand('up')
              : downHand('down')
          "
          :loading="loading"
        >
          确 认
        </el-button>
      </span>
    </el-dialog>

    <!--重启-->
    <el-dialog
      class="reload_dialog"
      :visible.sync="reload_dialog"
      width="30%"
      center
    >
      <div slot="title">
        <i class="el-icon-warning"></i>
      </div>
      <div class="Main">
        <div class="infoOne">确定要重启该机器吗？</div>
        <div class="infoTwo">5分钟内将无法再次重启！</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="loading" @click="reload_dialog = false"
          >取 消</el-button
        >
        <el-button
          type="danger"
          v-dacusClick
          @click="reloadHand"
          :loading="loading"
          >确 认</el-button
        >
      </span>
    </el-dialog>
    <!-- 日志下载 -->
    <el-dialog
      class="logVisible"
      width="800px"
      :visible.sync="logVisible"
      v-if="logVisible"
      @opened="$refs.log.getList()"
    >
      <cabinet-log ref="log" :hard_number="logData"></cabinet-log>
    </el-dialog>
    <!-- 待运营机器 -->
    <el-dialog width="800px" title="待运营机器" :visible.sync="operatedDialog">
      <el-form label-width="80px" :inline="true" size="small">
        <el-form-item label="机器编号">
          <el-input
            size="small"
            v-model="operatedSearch.hard_number"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="operatedQuery"
            >查询</el-button
          >
          <el-button size="small" type="primary" @click="operatedReset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
      <el-table style="width: 100%" :data="operateData">
        <el-table-column
          label="序号"
          type="index"
          align="center"
          :index="indexMethod"
        ></el-table-column>
        <el-table-column prop="hard_number" label="机器编号"> </el-table-column>
        <el-table-column prop="factory_time" label="出厂时间">
        </el-table-column>
        <el-table-column label="操作">
          <div slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              @click="operateRelocation(scope.row)"
              >移机</el-button
            >
          </div>
        </el-table-column>
      </el-table>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="operatedDialog = false">取 消</el-button>
        <el-button type="primary" @click="operatedDialog = false"
          >确 定</el-button
        >
      </span> -->
      <div class="paginationWrap">
        <el-pagination
          @current-change="operatehandleCurrentChange"
          :page-sizes="[10]"
          :page-size="page_Size"
          layout="total, sizes, prev, pager, next"
          :total="total_count"
        >
        </el-pagination>
      </div>
    </el-dialog>

    <!-- 二维码 -->
    <!-- <el-dialog
      class="down_dialog"
      :visible.sync="down_dialog"
      width="600px"
      center
    >
      <div class="Main borderGray">
        <el-table
          :header-cell-style="{ background: '#f5f5f5' }"
          :data="downCode_Data"
          style="width: 100%"
        >
          <el-table-column
            prop="size"
            label="二维码边长(cm)"
            align="center"
            width="180"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.size }}(cm)</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="meter"
            label="建议扫描距离(米)"
            align="center"
            width="180"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.meter }}(m)</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="下载链接">
            <template slot-scope="scope">
              <div class="el-icon-download" @click="downCode(scope.row)"></div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="down_dialog = false">关 闭</el-button>
      </span>
    </el-dialog> -->

    <!-- 陈列查看 -->
    <el-dialog :visible.sync="tempVisible" title="分类库存查看">
      <div style="margin:0 0 20px 0"><el-button size="small" type="primary" @click="confirmMX"> 库存恢复</el-button></div>
      <div>
        <span
          >可放总数量：{{ tempData.max_count }}件,剩余：{{
            tempData.remainder_count
          }}件，预警数量：{{ tempData.warn_count }}件</span
        >
      </div>
      <el-table
        :data="tempData.terminal_items"
        row-style="height:20px"
        width="100%"
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="商品名称" prop="name"></el-table-column>
        <el-table-column label="分类" prop="category_name"></el-table-column>
        <el-table-column label="商品编码" prop="number"></el-table-column>
        <el-table-column label="图片">
          <div slot-scope="scope">
            <img :src="scope.row.image_url" width="80px" height="80px" />
          </div>
        </el-table-column>
        <el-table-column label="商品重量(g)">
          <span slot-scope="scope"
            >{{ scope.row.min_weight }} ~ {{ scope.row.max_weight }}</span
          >
        </el-table-column>
        <el-table-column label="现有库存" prop="real_qty"></el-table-column>
        <el-table-column label="日均销售" prop="good_info"></el-table-column>
      </el-table>
    </el-dialog>
    <!--实时图片-->
    <el-dialog :visible.sync="stockPicVisible" title="实时图片">
      <el-table :data="stockPicList">
        <el-table-column label="层列" align="center">
          <div slot-scope="scope">第{{ scope.$index + 1 }}层</div>
        </el-table-column>
        <el-table-column label="图片" align="center">
          <div slot-scope="scope">
            <canvas
              :id="'canvas' + scope.row.line"
              width="1920"
              height="1080"
              style="width: 100%"
              @click="openImageDialog(scope.row.path, scope.row.data)"
              >您的浏览器不支持预览图片</canvas
            >
          </div>
        </el-table-column>
      </el-table>
    </el-dialog>
    <simple-find-dialog
      :show="dialogVisible"
      @close="closeSimpleDialog"
      :dialogData="dialogData"
      :width="'500px'"
    ></simple-find-dialog>
    <simple-print
      node="table"
      :table="tableList"
      :show="printVisible"
      @close="printVisible = false"
    ></simple-print>
    <!--查看canvas大图-->
    <el-dialog
      :visible.sync="dialogImageVisible"
      width="1320px"
      :fullscreen="true"
      @open="setImage"
    >
      <div style="text-align: center">
        <canvas id="canvasDialog" width="1920" height="1080"
          >您的浏览器不支持预览图片</canvas
        >
      </div>
    </el-dialog>
    <!-- 二维码 -->
    <el-dialog
      :visible.sync="qrcodeVisible"
     :width="qrcode2 ? '600px' : '300px'"
      :center="true"
      :show-close="false"
      class="qr-dialog"
    >
      <img :src="qrcode" width="300px" height="300px" />
      <img :src="qrcode2" width="300px" height="300px"  v-if="qrcode2"/>
    </el-dialog>
    <!-- 移机 -->
    <el-dialog title="移机选择" :visible.sync="relocationDialog" width="400px">
      <span style="margin-left: 12px">源客户：{{ this.rel_name }}</span>
      <el-form size="small" label-width="80px" style="margin-top: 15px">
        <el-form-item label="目标商户">
          <el-input
            style="width: 200px"
            size="small"
            v-model="company.company"
            suffix-icon="el-icon-search"
            readonly
            @focus="setDialogSearchItem('company')"
          ></el-input>
          <!-- <el-button type="primary" style="margin-left:12px" @click="choseCustomer">选择</el-button> -->
        </el-form-item>
        <span style="font-size: 80%; color: red"
          >注意：确认操作后，机器将移到目标客户，原先订单数据将保留在源商户</span
        >
        <span style="font-size: 80%; color: red">原库存保存七天，七天后自动删除</span> 
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="sureBtn">确认更改</el-button>
      </div>
    </el-dialog>
    <!-- 待运营机器移机 -->
    <el-dialog
      title="移机选择"
      :visible.sync="operateRelocationDialog"
      width="400px"
    >
      <span style="margin-left: 12px">源客户：{{ this.rel_name }}</span>
      <el-form size="small" label-width="80px" style="margin-top: 15px">
        <el-form-item label="目标商户">
          <el-input
            style="width: 200px"
            size="small"
            v-model="company.company"
            suffix-icon="el-icon-search"
            readonly
            @focus="setDialogSearchItem('company')"
          ></el-input>
          <!-- <el-button type="primary" style="margin-left:12px" @click="choseCustomer">选择</el-button> -->
        </el-form-item>
        <span style="font-size: 80%; color: red"
          >注意：确认操作后，机器将移到目标客户，原先订单数据将保留在源商户</span
        >
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="operateBtn">确认更改</el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog :visible.sync="detailsDialog" width="400px" title="机器详情">
      <el-form size="small" label-width="100px">
        <el-form-item label="MAC:" style="font-size: 40%">
          <span style="margin-left: 10px">{{ this.detailsDataMac }}</span>
        </el-form-item>
        <el-form-item label="SIM:" style="font-size: 40%">
          <span style="margin-left: 10px">{{ this.detailsDataSim }}</span>
        </el-form-item>
        <el-form-item label="下线操作人:" style="font-size: 40%">
          <span style="margin-left: 10px">{{ this.detailsDataoffline_operator }}</span>
        </el-form-item>
        <el-form-item label="下线时间:" style="font-size: 40%">
          <span style="margin-left: 10px">{{ this.detailsDataoffline_time }}</span>
        </el-form-item>
        <el-form-item label="下线原因:" style="font-size: 40%">
          <span style="margin-left: 10px">{{ this.detailsDataoffline_cause }}</span>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 温度控制 -->
    <el-dialog :visible.sync="temperatureDialog" width="400px" title="温度控制">
      <el-form size="small" label-width="80px">
        <el-form-item label="设置温度">
          <el-input style="width: 200px" v-model="temperature"></el-input
          ><span style="margin-left: 10px">℃</span>
        </el-form-item>
        <span style="color: red; font-size: 5%"
          >备注：温度填写范围：-30℃--30℃</span
        >
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="btnTemperature">确定</el-button>
      </span>
    </el-dialog>
    <!-- 温度批量控制 -->
    <el-dialog
      :visible.sync="controlTemperatureDialog"
      width="400px"
      title="温度控制"
    >
      <el-form size="small" label-width="80px">
        <el-form-item label="设置温度">
          <el-input style="width: 200px" v-model="temperature"></el-input
          ><span style="margin-left: 10px">℃</span>
        </el-form-item>
        <span style="color: red; font-size: 5%"
          >备注：温度填写范围：-30℃--30℃</span
        >
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="btnControlTemperature"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <!-- 音量控制 -->
    <el-dialog :visible.sync="volumeDialog" width="400px" title="音量控制">
      <el-form size="small" label-width="80px">
        <el-form-item label="音量强度">
          <el-select v-model="volume">
            <el-option
              v-for="i in 16"
              :key="i"
              :label="`${i - 1}级`"
              :value="`${i - 1}`"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="btnVolume">确定</el-button>
      </span>
    </el-dialog>
    <!-- 音量批量控制 -->
    <el-dialog
      :visible.sync="controlVolumeDialog"
      width="400px"
      title="音量批量控制"
    >
      <el-form size="small" label-width="80px">
        <el-form-item label="音量强度">
          <el-select v-model="volume">
            <el-option
              v-for="i in 16"
              :key="i"
              :label="`${i - 1}级`"
              :value="`${i - 1}`"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="btnControlVolume">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcode";
import BreadCrumb from "@/components/BreadCrumb";
import apis from "@/config/apis";
// import cabinetechart from "./cabinetechart";
import cabinetNetworkChart from "./cabinetNetworkChart";
import SimpleFindDialog from "@/components/SimpleFindDialog";
import SimplePrint from "@/components/SimplePrint";
import { terminalTypes, network_status } from "@/plugins/enum.js";
import { latJ, latW } from "@/plugins/common";
import alert from "@/plugins/alert";
import { download, downloadnew } from "@/plugins/util";
import listMixin from "@/mixins/list";
import cabinetLog from "./components/cabinetLog.vue";
export default {
  name: "CabinetMangement",
  mixins: [listMixin],
  components: {
    BreadCrumb,
    // cabinetechart,
    SimpleFindDialog,
    SimplePrint,
    cabinetNetworkChart,
    cabinetLog,
  },
  data() {
    var province = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("省不能为空"));
      }
      callback();
    };
    var city = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("市不能为空"));
      }
      callback();
    };
    var area = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("地区不能为空"));
      }
      callback();
    };
    var address = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("详细地址不能为空"));
      }
      callback();
    };
    return {
      temperatureDialog: false,
      detailsDialog:false,
      detailsDataMac:"",
      detailsDataSim:"",
      detailsDataoffline_operator:"",
      detailsDataoffline_time:"",
      detailsDataoffline_cause:"",
      volumeDialog: false,
      controlVolumeDialog: false,
      controlTemperatureDialog: false,
      volumeId: "",
      temperatureId: "",
      volume: "",
      temperature: "",
      rel_name: "",
      relocationDialog: false,
      operateDialog: false,
      operateRelocationDialog: false,
      total: "",
      lineCount: "",
      details: {
        details: true,
      },
      pageSize:10,
      search: {
        hard_number: "",
        terminal_number: "",
        line_id: "",
        status: "",
        terminal_type: "",
        company_id: "",
        point_id: "",
        point_type_id: "",
        network_status: "", //网络查询状态
        order_by: "s3",
        volume: "",
        is_join:false,
        page_index:1,
        page_size:10,
      },
      scopeObj: {
        id: "",
        label: "",
      },
      line: {},
      terminal_type: {},
      company: {},
      point: {},
      point_type: {},
      operationList: [
        {
          value: "look",
          label: "查看",
        },
        {
          value: "update",
          label: "修改",
        },
        {
          value: "detele",
          label: "删除",
        },
      ],
      typeOptions: terminalTypes,
      network: network_status, // 网络状态
      loading: false,
      XX_dialog: false,
      downData: {},
      reloadData: null,
      logData: null,
      temperatureData: null,
      detailsData:null,
      Showdialog: false,
      reload_dialog: false,
      logVisible: false,
      operatedDialog: false,
      caintechartShow: false,
      echart_dialog: false,
      chart: null,
      downRow: null, //下载对象
      downStatus: "", //购物还是补货
      down_dialog: false, //二维码弹窗
      downCode_Data: [
        {
          size: "8",
          meter: "0.5",
        },
        {
          size: "12",
          meter: "0.5",
        },
        {
          size: "15",
          meter: "1",
        },
        {
          size: "30",
          meter: "1.5",
        },
      ], //二维码数据
      latModel: {
        province: "", //省
        city: "", //市
        area: "", //区
        address: "", //详细地址
      },
      dialogVisible: false,
      dialogData: {},
      province_options: [],
      city_options: [],
      area_options: [],
      latRules: {
        province: [
          {
            validator: province,
            trigger: "blur",
            required: true,
          },
        ],
        city: [
          {
            validator: city,
            trigger: "blur",
            required: true,
          },
        ],
        area: [
          {
            validator: area,
            trigger: "blur",
            required: true,
          },
        ],
        address: [
          {
            validator: address,
            trigger: "blur",
            required: true,
          },
        ],
      },
      LatData: {}, //当前的货柜数据
      Lat_dialog: false, //经纬度 弹窗
      tempVisible: false, //弹窗模板
      tempData: {},
      RemPageIndex: 1, //当前余数
      nowDialog: "", //现在打开的弹窗里的类型
      printVisible: false,
      stockPicVisible: false,
      stockPicList: [],
      nodePath: "",
      nodeAxisList: [],
      dialogImageVisible: false,
      currentRow: null,
      qrcodeVisible: false,
      qrcode: "",
      qrcode2:"",
      relocationId: "",
      operateId: "",
      operateData: [],
      total_count: "",
      page_Size: "",
      biz_id:"",
      operatedSearch: {
        hard_number: "",
        page_index: 1,
        page_size: 10,
      },
      mxHard:"",
    };
  },
  watch: {
    search: {
      deep: true,
      handler(newVal) {
        localStorage.setItem("searchIndex", JSON.stringify(newVal));
      },
    },
  },
  created() {
    if(JSON.parse(localStorage.getItem("searchIndex"))){
      this.search = JSON.parse(localStorage.getItem("searchIndex"));
      this.searchBtn();
    } else if(this.$route.query.search){
      this.search = Object.assign(this.search, this.$route.query.search);
      let { query } = this.$route;
      (this.search.hard_number = query.search.hard_number || ""),
      (this.search.status = query.search.status || ""),
      (this.search.line_id = query.search.line_id || ""),
      (this.search.order_by = query.search.order_by || ""),
      (this.search.point_id = query.search.point_id || ""),
      (this.search.point_type_id = query.search.point_type_id || ""),
      (this.search.terminal_type = query.search.terminal_type || ""),
      (this.currentPage = query.currentPage ? parseInt(query.currentPage) : 1);
      this.searchBtn();
    }else{
      this.searchBtn();
    }
    this.biz_id = localStorage.getItem('biz_id')
    console.log(this.biz_id,'this.biz_id')
    console.log(typeof(this.biz_id),'this.biz_id')

  },
  mounted() {
    this.qrcodeList();
    // this.getCity()
  },
  methods: {
    openTemperature(row) {
      this.temperature = row.temperature;
      this.temperatureDialog = true;
      this.temperatureId = row.id;
    },
    controlVolume() {
      this.controlVolumeDialog = true;
    },
    controlTemperature() {
      this.controlTemperatureDialog = true;
    },
    controlHardNumber() {
      this.operatedDialog = true;
      this.operatedHardNumber();
    },
    openSound(row) {
      this.volumeDialog = true;
      this.volumeId = row.id;
      this.volume = row.volume;
    },
    btnControlVolume() {
      this.search.volume = new Number(this.volume);
      this.volumeTemperature();
      this.controlVolumeDialog = false;
      this.searchBtn();
    },
    btnControlTemperature() {
      this.search.temperature = new Number(this.temperature);
      this.volumeTemperature();
      this.controlTemperatureDialog = false;
    },
    // 待运营机器
    operatedHardNumber() {
      this.$axios
        .get(apis.hardNumberList, { params: this.operatedSearch })
        .then((res) => {
          console.log(res);
          this.operateData = res.data.data;
          this.total_count = res.data.pagination.total_count;
          this.page_Size = res.data.pagination.count;
        });
    },
    btnVolume() {
      if (this.volume) {
        this.$axios
          .post(apis.terminal_volume, {
            tid: this.volumeId,
            volume: new Number(this.volume),
          })
          .then((res) => {
            console.log(res);
            if (res.data.code === 200) {
              this.$message({
                type: "success",
                message: "音量调整成功",
              });
              this.searchBtn();
              this.volumeDialog = false;
            } else {
              this.$message({
                type: "error",
                message: "音量调整失败",
              });
              this.searchBtn();
              this.volumeDialog = false;
            }
          });
      } else {
        this.volumeTemperature();
        this.volumeDialog = false;
      }
    },
    volumeTemperature() {
      const loading = this.$loading({
        lock: true,
        text: "命令执行中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios.post(apis.batch_update_terminal, this.search).then((res) => {
        console.log(res);
        if (res.status === 200) {
          loading.close();
          this.$message({
            type: "success",
            message: "批量控制成功",
          });
          this.temperature = "";
          this.searchBtn();
        } else {
          loading.close();
          this.$message({
            type: "error",
            message: "批量控制失败",
          });
          this.temperature = "";
          this.searchBtn();
        }
      });
    },
    btnTemperature() {
      this.$axios
        .post(apis.terminal_temperature, {
          tid: this.temperatureId,
          temperature: new Number(this.temperature),
        })
        .then((res) => {
          console.log(res);
          if (res.data.code === 200) {
            this.$message({
              type: "success",
              message: "温度调整成功",
            });
            this.searchBtn();
          } else {
            this.$message({
              type: "error",
              message: "温度调整失败",
            });
            this.searchBtn();
          }
        });
      this.temperatureDialog = false;
      this.temperature = "";
    },
    operatedQuery() {
      this.operatedHardNumber();
    },
    operatedReset() {
      this.operatedSearch.hard_number = "";
      this.operatedHardNumber();
    },
    // 待运营机器移机
    operateRelocation(row) {
      (this.operateId = row.tid), (this.operateRelocationDialog = true);
    },
     operateBtn() {
      this.$axios
        .post(apis.move_contract_terminal, {
          tid: this.operateId,
          biz_user_id: this.search.company_id,
        })
        .then((res) => {
          console.log(res);
          if (res.data.msg === "移机成功") {
            this.$message({
              type: "success",
              message: "移机成功",
            });
          } else {
            this.$message({
              type: "error",
              message: "移机失败",
            });
          }
        });
      this.operateRelocationDialog = false;
      this.operatedDialog = false;
      this.company.company = "";
    },
    // 移机
    Relocation(row) {
      console.log(row);
      (this.relocationId = row.id), (this.relocationDialog = true);
    },
    // 确认更改
    sureBtn() {
      this.$axios
        .post(apis.move_terminal, {
          tid: this.relocationId,
          biz_user_id: this.search.company_id,
        })
        .then((res) => {
          console.log(res);
          if (res.data.msg === "更改成功") {
            this.$message({
              type: "success",
              message: "移机更改成功",
            });
          } else {
            this.$message({
              type: "error",
              message: "移机更改失败",
            });
          }
        });
      this.relocationDialog = false;
      this.company.company = "";
    },

    
 
  
    // 是否自动清理空单
    changeEmptyOrder(row) {
      let rowId = row.id;
      this.$axios.get(`${apis.ch_auto_clear}/${rowId}`).then((res) => {
        if (res.data.msg === "开启成功") {
          this.$message({
            message: "开启成功",
            type: "success",
          });
        } else if (res.data.msg === "关闭成功") {
          this.$message({
            message: "关闭成功",
            type: "success",
          });
        }
      });
    },
    //打开二维码
    openQrcode(hard_number) {
      this.qrcode2 = '';
      if (hard_number.startsWith('955BZN')) {
  QRCode.toDataURL(`http://qr.magexiot.com/fresh/?mid=${hard_number}&coupe=${1}`)
    .then((url) => {
      console.log(url);
      this.qrcodeVisible = true;
      this.qrcode = url;
    })
    .catch((err) => {
      console.error(err);
    });
  QRCode.toDataURL(`http://qr.magexiot.com/fresh/?mid=${hard_number}&coupe${2}`)
    .then((url) => {
      console.log(url);
      this.qrcodeVisible = true;
      this.qrcode2 = url;
    })
    .catch((err) => {
      console.error(err);
    });
  return; // 阻止后续执行
}
      if (this.biz_id === '11' || this.biz_id === '42') {
  QRCode.toDataURL(`http://qr.magexiot.com/fresh/?mid=${hard_number}`)
    .then((url) => {
      console.log(url);
      this.qrcodeVisible = true;
      this.qrcode = url;
    })
    .catch((err) => {
      console.error(err);
    });
  return; // 阻止后续执行
}



QRCode.toDataURL(`http://qr.magexiot.com/cli/?mid=${hard_number}`)
  .then((url) => {
    console.log(url);
    this.qrcodeVisible = true;
    this.qrcode = url;
  })
  .catch((err) => {
    console.error(err);
  });

    
    },
    // 点击编辑icon图标触发
    edit(scope) {
      console.log(scope);
      this.scopeObj.id = scope.row.id;
      this.scopeObj.label = scope.column.label;
      this.$nextTick(() => {
        this.$refs.iptRef.focus();
      });
    },
    // 失去焦点
    inputBlur(row) {
      console.log(row);
      this.currentRow = row;
      this.scopeObj = {
        id: "",
        label: "",
      };
      this.editGoods();
    },
    editGoods() {
      const { terminal_number, id } = this.currentRow;
      let data = {
        terminal_number,
        tid: id,
      };
      this.$axios
        .post(`${apis.update_terminal_name}/${id}`, data)
        .then((res) => {
          console.log(res);
          if (res.status === 200) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
          } else {
            this.$message.error("修改失败");
          }
        });
    },
    /*search*/
    searchBtn(cl) {
      this.getTableData(apis.terminal_list, "get", this.search).then((res) => {
        console.log(res);
        this.lineCount = res.data.pagination;
        this.total = res.data.pagination.total_count;
        this.rel_name = res.data.data[0].rel_name;
      });
    },
    // searchBtn(cl) {
    //   this.$axios(apis.terminal_list, "get", this.search).then(res=>{
    //     console.log(res);
    //   })
    // },

    /*重置 按钮*/
    resetBtn() {
      this.line = {};
      this.terminal_type = {};
      this.point = {};
      this.point_type = {};
      // this.company = {};
      this.search = {
        hard_number: "",
        line_id: "",
        status: "",
        terminal_type: "",
        // company_id: "",
        point_id: "",
        point_type_id: "",
        order_by: "s3",
        page_index:1,
        page_size:10,
      };
      this.searchBtn();
    },
    /*新增*/
    addBtn() {
      this.$router.push({
        path: "cabinetUpdate",
        query: {
          operateType: "add",
        },
      });
    },
    /*导出*/
    outDown() {
      this.$loading({
        lock: true,
        text: "数据下载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let url = `${apis.terminal_export}`;
      download(this, url, "货柜.xls").then(() => {
        this.$loading().close();
      });
    },
    // 导出机器明细库存
    printBtn() {
      this.$loading({
        lock: true,
        text: "数据下载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // let url = `${apis.terminal_export}`;
      // downloadnew(this,url, "机器明细库存.xls",this.details);
      downloadnew(this, apis.terminal_export, "机器明细库存.xls", {
        details: this.details,
      }).then(() => {
        this.$loading().close();
      });
    },
    /*打印*/
    // printBtn() {
    //   this.printVisible = true;
    // },
    /*温湿度*/
    drawLine(row) {
      this.$refs.cabinetechart.show({
        hard_number: row.hard_number,
      });
    },

    /*默认地区*/
    getCity(type = "default") {
      let params = {
        pid: this.latModel.province,
        cid: this.latModel.city,
      };
      this.$axios
        .get(apis.getCity, {
          params,
        })
        .then((data) => {
          let datas = data.data;
          if (datas.code === 200) {
            if (type === "default") {
              this.province_options = datas.data;
              this.city_options = [];
            } else if (type === "province") {
              this.city_options = datas.data;
              this.area_options = [];
            } else if (type === "city") {
              this.area_options = datas.data;
            }
          }
        });
    },

    /*省选择*/
    provinceChange(data) {
      this.latModel.city = "";
      this.latModel.area = "";
      this.getCity("province");
    },
    /*市选择*/
    cityChange() {
      this.latModel.area = "";
      this.getCity("city");
    },

    /* 查看 修改 删除 */
    btnDetal(type, ele) {
      if (type === "look") {
        this.$router.push({
          path: "cabinetUpdate",
          query: {
            hard_number: ele.$attrs.hard_number,
            operateType: type,
            search: this.search,
          },
        });
      } else if (type === "update") {
        this.$router.push({
          path: "cabinetUpdate",
          query: {
            hard_number: ele.$attrs.hard_number,
            operateType: type,
            search: this.search,
          },
        });
      } else if (type === "detele") {
        alert.deleteAlert().then((next) => {
          this.$axios
            .delete(apis.terminal_delete, {
              params: {
                hard_number: ele.$attrs.hard_number,
              },
            })
            .then((res) => {
              if (res.data.code === 200) {
                this.searchBtn();
              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg,
                });
              }
            });
        });
      }
    },

    confirmMX(){
      alert.kcAlert().then(next => {
        this.$axios.get(apis.inventory_transfer  + this.mxHard+"/").then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.getData();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
      });
    },

    /*显示经纬度弹窗*/
    /*latBtn(data) {
          this.Lat_dialog = true
          this.LatData = data
          let params = {
            "hard_number": data.hard_number
          }
          this.$axios.get(apis.detailLocation,{params}).then( data => {
            let datas = data.data
            if(datas.code === 200) {

                this.province_options = datas.data.province_list;
                this.city_options = datas.data.city_list;
                this.area_options = datas.data.area_list;
                let {terminal_position:{id,cid,pid,address}} = datas.data
                this.latModel = {
                  province: pid, //省
                  city: cid, //市
                  area: id, //区
                  address: address, //详细地址
              };

            } else {
              this.$message({
                type: 'error',
                message: datas.msg
              })
            }
          })
        },*/
    /*省市区确认接口*/
    LatHand() {
      // this.LatData
      this.$refs["latForm"].validate((valid) => {
        if (valid) {
          let jsonData = {
            hard_number: this.LatData.hard_number,
            area_code: this.latModel.area,
            address: this.latModel.address,
          };
          this.$axios.post(apis.updateLocation, jsonData).then((data) => {
            let datas = data.data;
            if (datas.code === 200) {
              this.$message({
                type: "success",
                message: datas.msg,
              });
              // this.searchBtn()
              this.Lat_dialog = false;
              // this.$refs.latForm.clearValidate()
            } else {
              this.$message({
                type: "error",
                message: datas.msg,
              });
              return false;
            }
          });
        }
      });
    },

    /*省市区弹窗关闭*/
    Lat_Close() {
      this.$refs.latForm.resetFields();
    },

    /*二维码 列表*/
    qrcodeList() {},

    /*显示 下载弹窗*/
    // goDown(row, type) {
    //   this.downRow = row;
    //   this.down_dialog = true;
    //   this.downStatus = type === "GW" ? "shopping" : "replenishment";
    // },
    /* 下载 */
    // downCode(row) {
    //   let params = {
    //     terminal_id: this.downRow.hard_number,
    //     height: row.size,
    //   };
    //   this.$axios
    //     .get(apis.qrcode, {
    //       params,
    //     })
    //     .then((data) => {
    //       let datas = data.data;
    //       if (datas.code === 200) {
    //         this.downloadIamge(datas.data.url, datas.data.name);
    //       }
    //     });
    // },

    downloadIamge(imgsrc, name) {
      //下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    downHand(type) {
      let data = this.downData;
      this.loading = true;
      let url = "";
      if (type === "up") {
        url = `${apis.start}/${data.id}`;
      } else {
        url = `${apis.shutdown}/${data.id}`;
      }
      this.$axios.post(url, data).then((data) => {
        let datas = data.data;
        this.XX_dialog = false;
        this.loading = false;
        if (datas.code == 200) {
          this.$message({
            type: "success",
            message: datas.msg,
          });
          this.searchBtn();
        } else {
          this.$message({
            type: "error",
            message: datas.msg,
          });
        }
      });
    },
    reloadHand() {
      this.loading = true;
      this.$axios
        .get(apis.restart, {
          params: {
            mid: this.reloadData,
          },
        })
        .then((data) => {
          let datas = data.data;
          this.reload_dialog = false;
          this.loading = false;
          if (datas.code == 200) {
            this.$message({
              type: "success",
              message: datas.msg,
            });
            this.searchBtn();
          } else {
            this.$message({
              type: "error",
              message: datas.msg,
            });
          }
        });
    },
    /*陈列查看*/
    exhibit(hard_number) {
      this.tempVisible = true;
      let params = {
        hard_number: hard_number,
      };
      this.tempData = [];
      this.$axios
        .get(apis.terminal_items, {
          params,
        })
        .then((res) => {
          this.tempData = res.data.data;
        });
    },
    //打开弹出选择配置
    setDialogSearchItem(type) {
      switch (type) {
        case "terminal_types":
          this.dialogData = {
            searchItems: [
              {
                key: "name",
                label: "产品型号",
              },
            ],
            searchTableItem: [
              {
                key: "name",
                name: "类型名称",
              },
            ],
            proxyLink: "category_list_by_contract",
            proxyType: "get",
          };
          break;
        case "point":
          this.dialogData = {
            searchItems: [
              {
                key: "name",
                label: "点位",
              },
              {
                key: "line_id",
                value: this.search.line_id,
                hidden: true,
              },
            ],
            searchTableItem: [
              {
                key: "name",
                name: "点位名称",
              },
            ],
            proxyLink: "terminal_point_by_line",
            proxyType: "post",
          };
          break;
        case "line":
          this.dialogData = {
            searchItems: [
              {
                key: "name",
                label: "线路名称",
              },
            ],
            searchTableItem: [
              {
                key: "name",
                name: "线路名称",
              },
            ],
            proxyLink: "terminal_line",
            proxyType: "get",
          };
          break;
        case "pointType":
          this.dialogData = {
            searchItems: [
              {
                key: "name",
                label: "点位类型",
              },
            ],
            searchTableItem: [
              {
                key: "name",
                name: "点位类型",
              },
            ],
            proxyLink: "getPointType",
            proxyType: "post",
          };
          break;
        case "company":
          this.dialogData = {
            searchItems: [
              {
                key: "company",
                label: "商户名称",
              },
            ],
            searchTableItem: [
              {
                key: "company",
                name: "商户名称",
              },
            ],
            proxyLink: "get_users",
            proxyType: "get",
          };
          break;
      }
      this.dialogVisible = true;
      this.nowDialog = type;
    },
    //分页-当前页
    handleCurrentChange(page) {
      this.search.page_index = page;
      this.searchBtn();
    },
    operatehandleCurrentChange(page) {
      console.log(page);
      this.operatedSearch.page_index = page;
      this.operatedHardNumber();
    },
    //关闭简单弹出窗口（选择）TODO:
    closeSimpleDialog(data) {
      console.log(data);
      this.dialogVisible = false;
      switch (this.nowDialog) {
        case "terminal_types":
          this.terminal_type = data ? data : {};
          this.search.terminal_type = this.terminal_type.id;
          break;
        case "point":
          this.point = data ? data : {};
          this.search.point_id = this.point.id;
          break;
        case "line":
          this.line = data ? data : {};
          this.search.line_id = this.line.id;
          break;
        case "pointType":
          this.point_type = data ? data : {};
          this.search.point_type_id = this.point_type.id;
          break;
        case "company":
          this.company = data ? data : {};
          this.search.company_id = this.company.id;
          console.log(this.search.company_id);
          break;
      }
    },
    //下拉（上线，下线，重启）
    machineOperate(type, ele) {
      console.log(type, ele);
      switch (type) {
        case "online":
        case "offline":
          this.downData = this.tableList.filter((item) => {
            return item.id == ele.$attrs.itemId;
          });
          this.downData = this.downData[0];
          this.XX_dialog = true;
          break;
        case "restart":
          this.reloadData = ele.$attrs.hard_number;
          this.reload_dialog = true;
          break;
        case "logDownload":
          this.logData = ele.$attrs.hard_number;
          // console.log(this.logData);
          this.logVisible = true;
          // this.$axios.get(apis.terminal_android_log,{hard_number:this.logData}).then(res=>{
          //   console.log(res);
          // })
          break;
        case "operated":
          this.operatedDialog = true;
          break;
        case "volume":
          this.volumeData = ele.$attrs.row;
          this.volumeId = this.volumeData.id;
          this.volume = this.volumeData.volume;
          this.volumeDialog = true;
          break;
        case "temperature":
          this.temperatureData = ele.$attrs.row;
          this.temperatureId = this.temperatureData.id;
          this.temperature = this.temperatureData.temperature;
          this.temperatureDialog = true;
          break;
          case "detailsInformation":
          this.detailsData = ele.$attrs.row;
          this.detailsDialog = true;
          this.detailsDataMac = this.detailsData.mac;
          this.detailsDataSim = this.detailsData.sim;
          this.detailsDataoffline_operator = this.detailsData.offline_operator;
          this.detailsDataoffline_time = this.detailsData.offline_time;
          this.detailsDataoffline_cause = this.detailsData.offline_cause;
          break;
        case "unlock":
          this.$loading({
            lock: true,
            text: "开锁中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          this.$axios
            .post(apis.terminal_unlock, {
              mid: ele.$attrs.hard_number,
              coupe: 3,
            })
            .then((res) => {
              this.$loading().close();
              if (res.data.code === 200) {
                this.$message({
                  type: "success",
                  message: "开锁成功",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "开锁失败",
                });
              }
            });
          break;
        case "update_lock_status":
          this.$axios
            .get(apis.reset_terminal_status, {
              params: {
                mid: ele.$attrs.hard_number,
              },
            })
            .then((res) => {
              if (res.data.code === 200) {
                this.$message({
                  type: "success",
                  message: "清锁成功",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "清锁失败",
                });
              }
            });
          break;
      }
    },
    //库存操作(上下架，更换商品，更换货道)
    stockOperate(type, ele) {
      let _operate = "";
      switch (type) {
        case "online":
          _operate = "UP";
          break;
        case "offline":
          _operate = "DOWN";
          break;
        case "changeGoods":
          _operate = "REPLACE_ITEMS";
          break;
        case "changeGoodsWay":
          _operate = "REPLACE";
          break;
      }
      if (
        _operate === "UP" ||
        _operate === "DOWN" ||
        _operate === "REPLACE_ITEMS"
      ) {
        this.$router.push({
          name: "StockGoodsManage",
          query: {
            hard_number: ele.$attrs.hard_number,
            business_type: _operate,
            redirect: this.$route.name,
          },
          params: this.$route.query,
        });
      } else {
        this.$router.push({
          name: "cabinetUpdate",
          query: {
            hard_number: ele.$attrs.hard_number,
            operateType: "replace",
          },
          params: this.$route.query,
        });
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.hard_status !== "正常" || row.network_status !== "在线") {
        // return 'warning-row'
      } else if (row.status_name === "EXPIRE") {
        return "error-row";
      }
    },
    openVideoView(hard_number) {
      this.$router.push({
        name: "VideoView",
        query: {
          mid: hard_number,
          redirect: "terminal",
        },
        params: this.$route.query,
      });
    },
    //打开历史库存
    openStockHistory() {
      this.$router.push({
        name: "stockHistory",
      });
    },
    //库存查看
    stockView(hard_number) {
      // console.log(hard_number);
      this.exhibit(hard_number);
      this.mxHard = hard_number;
    },
    //库存查看
    // stockView(type, ele) {
    //   let hard_number = ele.$attrs.hard_number;
    //   switch (type) {
    //     case "1":
    //       this.exhibit(hard_number);
    //       break;
    //     case "2":
    //       this.showStockPic(hard_number);
    //       break;
    //   }
    // },
    showStockPic(hard_number) {
      this.$axios
        .get(`${apis.get_terminal_on_time_image}/${hard_number}`)
        .then((res) => {
          this.stockPicVisible = true;
          this.stockPicList = res.data.data;
        })
        .then(() => {
          this.stockPicList.forEach((item) => {
            this.setCanvas(`canvas${item.line}`, item.path, item.data);
          });
        });
    },
    setCanvas(id, path, axisList) {
      let img = new Image();
      img.src = path;
      let _canvas = document.getElementById(id);
      let ctx = _canvas.getContext("2d");
      img.onload = () => {
        let barcodeList = [];
        let barcodeAverage = [];
        let averageValue = [];
        let colors = [
          "#DC143C",
          "#0000FF",
          "#00FF7F",
          "#FFD700",
          "#FF69B4",
          "#FF1493",
          "#C71585",
          "#DA70D6",
          "#9400D3",
          "#4B0082",
          "#7B68EE",
          "#1E90FF",
          "#FFFF00",
          "#FFA500",
          "#8B4513",
        ];
        ctx.drawImage(img, 0, 0, 1920, 1080);
        if (axisList) {
          //去重barcode数组并添加值到平均数组列表中
          for (let i = 0; i < axisList.length; i++) {
            if (barcodeList.indexOf(axisList[i].name) < 0) {
              barcodeList.push(axisList[i].name);
              averageValue.push([axisList[i].score]);
            } else {
              averageValue[barcodeList.indexOf(axisList[i].name)].push(
                axisList[i].score
              );
            }
          }
          //计算平均值
          averageValue.forEach((item) => {
            const _item =
              (item.reduce((acc, val) => acc + val, 0) / item.length) * 100;
            barcodeAverage.push(_item.toFixed(2) + "%");
          });
          barcodeList = Array.from(new Set(barcodeList));
          //实心矩形
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(20, 20, 200, 28 * barcodeList.length + 20);
          //输出文字
          for (let i = 0; i < barcodeList.length; i++) {
            ctx.font = "12px Arial";
            ctx.fillStyle = colors[i];
            ctx.fillText(
              barcodeList[i] + "    " + barcodeAverage[i],
              34,
              28 * (i + 1) + 20
            );
          }
          // 输出矩形
          for (
            let axiosIndex = 0, xmin = 0, ymin = 0, xmax = 0, ymax = 0;
            axiosIndex < axisList.length;
            axiosIndex++
          ) {
            xmin = axisList[axiosIndex].xmin;
            xmax = axisList[axiosIndex].xmax;
            ymin = axisList[axiosIndex].ymin;
            ymax = axisList[axiosIndex].ymax;
            let axisListname = axisList[axiosIndex].name;
            ctx.lineWidth = "4";
            ctx.strokeStyle = colors[barcodeList.indexOf(axisListname)];
            //添加单个标注的框
            ctx.moveTo(xmin, ymin);
            ctx.lineTo(xmax, ymin);
            ctx.lineTo(xmax, ymax);
            ctx.lineTo(xmin, ymax);
            ctx.lineTo(xmin, ymin);
            ctx.stroke();
            //添加单个标注文字背景
            ctx.fillStyle = ctx.strokeStyle;
            ctx.fillRect(xmin - 2, ymin - 20, 30, 20);
            //添加单个标注的文字
            ctx.font = "12px Arial";
            ctx.fillStyle = "#FFFFFF";
            ctx.fillText(
              (axisList[axiosIndex].score * 100).toFixed(2) + "%",
              xmin + 2,
              ymin - 5
            );
            ctx.beginPath();
          }
        }
      };
    },
    //打开图片全屏
    openImageDialog(path, axisList) {
      this.dialogImageVisible = true;
      this.nodePath = path;
      this.nodeAxisList = axisList;
    },
    setImage() {
      let _that = this;
      setTimeout(function () {
        _that.setCanvas("canvasDialog", _that.nodePath, _that.nodeAxisList);
      }, 0);
    },
    //排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "network_status" && column.order === "ascending") {
        this.search.order_by = "s3";
      } else if (
        column.prop === "network_status" &&
        column.order === "descending"
      ) {
        this.search.order_by = "s4";
      }
      if (column.prop === "total_stock" && column.order === "ascending") {
        this.search.order_by = "s1";
      } else if (
        column.prop === "total_stock" &&
        column.order === "descending"
      ) {
        this.search.order_by = "s2";
      }
      if (!column.prop) {
        this.search.order_by = "";
      }
      if (!column.order) {
        this.search.order_by = "";
      }
      this.searchBtn();
    },
    //获取网络强度曲线图
    getNetworkStrength(hard_number) {
      this.$refs.cabinetNetworkChart.show({
        hard_number: hard_number,
      });
    },
  },
};
</script>
<style>
.el-table .warning-row {
  background: #fdf6ec;
}

.el-table .error-row {
  background: #fef1f1;
}
</style>
<style lang="scss" scoped>
.mr15 {
  margin-right: 15px;
}
.unset {
  user-select: unset;
}
.paginationWrap {
  padding: 10px 0;
  text-align: right;
}

.downCode {
  display: inline-block;
  padding: 0 6px;
  cursor: pointer;
}

.temper {
  // width: 40px;
  cursor: pointer;
  display: inline-block;
}

.icon-iconCodes {
  width: 26px;
  height: 26px;
  margin-top: -25px;
  margin-left: 10px;
  cursor: pointer;
  vertical-align: middle;
}

.icon-iconCode {
  width: 26px;
  height: 26px;
  vertical-align: middle;
}

/* 位置弹窗 */
.reload_dialog {
  .lineItem {
    width: 102px;
  }

  .leftMrgin {
    margin-left: 10px;
  }

  .blockAddarea {
    display: block;
  }

  .btngroupCenter {
    margin: 0 auto;
    text-align: center;
    display: block;
  }
}

.smallSelect {
  width: 100px;
  margin-left: 10px;
}

/*弹窗*/
.el-icon-download {
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 6px;
  cursor: pointer;
}

.el-icon-warning {
  color: #e6a23c;
  font-size: 60px;
}

.borderGray {
  border: 1px solid rgba(0, 0, 0, 0.13);
}

.Main {
  text-align: center;

  .infoOne {
    font-size: 28px;
    line-height: normal;
  }

  .infoTwo {
    padding-top: 10px;
    font-size: 14px;
  }
}

.text-warning {
  color: #e6a23c;
}

.text-success {
  color: #67c23a;
}

.text-error {
  color: #f56c6c;
}
.text-grey {
  color: #9a9494;
}
</style>
<style lang="scss">
.dialogMY {
  .el-dialog__body {
    padding: 20px 25px 25px;
  }
}

.blockAddarea {
  .el-form-item__content {
    display: block;
  }
}
.qr-dialog .el-dialog__header {
  padding: 0;
}
.qr-dialog .el-dialog__body {
  padding: 0;
}
.operate-con {
  display: flex;
  // justify-content: space-between;
  .operate-flex {
    display: flex;
    margin-left: 25%;
    margin-top: 10px;
  }
}
</style>
